module.exports = __webpack_public_path__ + "media/src/img/payment/visa-logo-600590e89406f144ebe8d3c529fe956d.svg";